import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import { BsFillMenuButtonFill, BsShop } from "react-icons/bs";

import { CiBoxList } from "react-icons/ci";
import { MdOutlinePlaylistAdd } from "react-icons/md";
import { MdInventory } from "react-icons/md";
import { BsFillGearFill } from "react-icons/bs";
import { RiAdminFill } from "react-icons/ri";
import { RiFileAddFill } from "react-icons/ri";
import { RiBarChartLine } from "react-icons/ri";
import { AiFillPrinter } from "react-icons/ai";
import { FaArrowTrendUp } from "react-icons/fa6";
import { FaArrowRightToCity } from "react-icons/fa6";
import { TbReportAnalytics, TbTruckDelivery } from "react-icons/tb";
import { MdOutlineRemoveShoppingCart, MdAccessTime, MdPayment, MdLocationOn, MdGridView, MdPointOfSale, MdDiscount } from "react-icons/md";
import { FaWhatsapp, FaHandHoldingUsd } from "react-icons/fa";
import { FaBoxOpen, FaUsers as FaUsersReport } from "react-icons/fa";
import { PiCashRegister } from "react-icons/pi";
import { LuImport } from "react-icons/lu";
import { BsRobot } from "react-icons/bs";
import { MdTableBar } from "react-icons/md";
import { MdShield } from "react-icons/md";
import { FiUsers } from "react-icons/fi";

import { isFeatureEnabled } from '../../hooks/useFeatureFlag';

// Internal function that returns all sidebar items (some have requiredFeature)
const allSidebarData = (t) => [
  {
    title: t('menu.myOrders'),
    path: "/",
    permission: "default",
    rbacPermission: null, // Sempre visivel - todos os roles veem pedidos
    moduleKey: "pedidos",
    icon: <MdGridView style={{ fontSize: "20px" }} />,
  },
  {
    title: t('menu.whatsapp'),
    path: "/whatsapp",
    permission: "default",
    rbacPermission: "whatsapp:config",
    moduleKey: "whatsapp",
    icon: <FaWhatsapp style={{ fontSize: "20px" }} />,
  },
  {
    title: t('menu.counterOrders'),
    path: "/pdv",
    permission: "default",
    rbacPermission: null, // Sempre visivel - todos os roles veem pedidos
    moduleKey: "pdv",
    icon: <MdPointOfSale style={{ fontSize: "20px" }} />,
  },
  {
    title: t('menu.cashier'),
    path: "/caixa",
    permission: "default",
    rbacPermission: "caixa:view",
    moduleKey: "caixa",
    icon: (
      <PiCashRegister style={{ fontSize: "20px" }} />
    ),
  },
  {
    title: t('menu.stock'),
    path: "/gestao-estoque",
    permission: "default",
    rbacPermission: "estoque:read",
    moduleKey: "estoque",
    icon: (
      <MdInventory style={{ fontSize: "20px" }} />
    ),
  },
  {
    title: t('menu.team'),
    path: "/team",
    permission: "default",
    rbacPermission: "users:manage",
    moduleKey: "equipe",
    icon: <FiUsers style={{ fontSize: "20px" }} />,
  },
  {
    title: t('menu.drivers'),
    path: "/list-entregadores",
    permission: "default",
    rbacPermission: "entregadores:manage",
    moduleKey: "entregadores",
    icon: (
      <TbTruckDelivery
        style={{ fontSize: "20px" }}
      />
    ),
  },
  {
    title: t('menu.storeInfo'),
    path: "/informacoes-loja",
    permission: "default",
    rbacPermission: "empresa:config",
    moduleKey: "informacoes_loja",
    icon: (
      <BsShop
        style={{ fontSize: "20px" }}
      />
    ),
  },
  {
    title: t('menu.menu'),
    permission: "default",
    rbacPermission: "catalogo:write",
    moduleKey: "cardapio",
    icon: (
      <BsFillMenuButtonFill
        style={{ fontSize: "20px" }}
      />
    ),
    iconClosed: (
      <RiIcons.RiArrowDownSFill
        style={{
          marginLeft: "-5px",
          fontSize: "20px",
        }}
      />
    ),
    iconOpened: (
      <RiIcons.RiArrowUpSFill
        style={{
          marginLeft: "-5px",
          fontSize: "20px",
        }}
      />
    ),

    subNav: [
      {
        title: t('menu.menuManager'),
        path: "/list-categoria",
        icon: (
          <CiBoxList
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.addons'),
        path: "/list-adicional",
        icon: (
          <MdOutlinePlaylistAdd
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
    ],
  },
  {
    title: t('menu.reports'),
    permission: "default",
    rbacPermission: "relatorios:view",
    moduleKey: "relatorios",
    icon: (
      <TbReportAnalytics
        style={{ fontSize: "20px" }}
      />
    ),
    iconClosed: (
      <RiIcons.RiArrowDownSFill
        style={{
          marginLeft: "-5px",
          fontSize: "20px",
        }}
      />
    ),
    iconOpened: (
      <RiIcons.RiArrowUpSFill
        style={{
          marginLeft: "-5px",
          fontSize: "20px",
        }}
      />
    ),

    subNav: [
      {
        title: t('menu.general'),
        path: "/relatorio-geral",
        icon: (
          <RiBarChartLine
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.performance'),
        path: "/desempenho",
        icon: (
          <FaArrowTrendUp
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.driversFees'),
        path: "/relatorio-entregadores",
        icon: (
          <TbTruckDelivery
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.tips'),
        path: "/relatorio-gorjetas",
        icon: (
          <FaHandHoldingUsd
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.abandonedCarts'),
        path: "/carrinhos-abandonados",
        icon: (
          <MdOutlineRemoveShoppingCart
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.salesByProduct'),
        path: "/relatorio-produtos",
        icon: (
          <FaBoxOpen
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.geographicAnalysis'),
        path: "/relatorio-geografico",
        icon: (
          <MdLocationOn
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.customerAnalysis'),
        path: "/relatorio-clientes",
        icon: (
          <FaUsersReport
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.paymentMethods'),
        path: "/relatorio-pagamentos",
        icon: (
          <MdPayment
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.peakHours'),
        path: "/relatorio-horarios",
        icon: (
          <MdAccessTime
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.discounts'),
        path: "/relatorio-descontos",
        icon: (
          <MdDiscount
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
      {
        title: t('menu.stockReport'),
        path: "/relatorio-estoque",
        icon: (
          <MdInventory
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
    ],
  },
  {
    title: t('menu.tables'),
    permission: "default",
    rbacPermission: "mesas:manage",
    moduleKey: "salao",
    icon: <MdTableBar style={{ fontSize: "20px" }} />,
    subNav: [
      {
        title: t('menu.tablesManage'),
        path: "/pedidos-mesas",
        icon: <MdTableBar style={{ fontSize: "20px" }} />,
        cName: "sub-nav",
      },
      {
        title: t('menu.waiters'),
        path: "/mesas-garcons",
        icon: (
          <FaIcons.FaUsers
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
    ],
  },
  {
    title: t('menu.myAccount'),
    permission: "default",
    rbacPermission: "empresa:billing",
    moduleKey: "minha_conta",
    icon: (
      <FaIcons.FaRegUser
        style={{ fontSize: "20px" }}
      />
    ),
    iconClosed: (
      <RiIcons.RiArrowDownSFill
        style={{
          marginLeft: "-5px",
          fontSize: "20px",
        }}
      />
    ),
    iconOpened: (
      <RiIcons.RiArrowUpSFill
        style={{
          marginLeft: "-5px",
          fontSize: "20px",
        }}
      />
    ),

    subNav: [
      {
        title: t('menu.plans'),
        path: "/planos",
        icon: (
          <IoIcons.IoIosPaper
            style={{ fontSize: "20px" }}
          />
        ),
        cName: "sub-nav",
      },
    ],
  },
  {
    title: t('menu.settings'),
    icon: (
      <BsFillGearFill style={{ fontSize: "20px" }} />
    ),
    permission: "default",
    rbacPermission: "empresa:config",
    moduleKey: "configuracoes",
    iconClosed: (
      <RiIcons.RiArrowDownSFill
        style={{
          marginLeft: "-5px",
          fontSize: "20px",
        }}
      />
    ),
    iconOpened: (
      <RiIcons.RiArrowUpSFill
        style={{
          marginLeft: "-5px",
          fontSize: "20px",
        }}
      />
    ),

    subNav: [
      {
        title: t('menu.printer'),
        path: "/impressora",
        icon: (
          <AiFillPrinter
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.acceptedPayments'),
        path: "/formas-pagamento",
        icon: (
          <FaIcons.FaMoneyCheckAlt
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.myOrdersConfig'),
        path: "/meus-pedidos-configuracao",
        icon: (
          <AiIcons.AiOutlineTool
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.botConfig'),
        path: "/robo-configuracao",
        icon: (
          <BsRobot
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.importMenu'),
        path: "/importacao-cardapio",
        requiredFeature: 'menuImport',
        icon: (
          <LuImport
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.stockManagement'),
        path: "/gestao-estoque?tab=configuracoes",
        icon: (
          <MdInventory
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.supportPrivacy'),
        path: "/privacidade-suporte",
        icon: (
          <MdShield
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.tunaPayments'),
        path: "/configuracao-tuna",
        requiredFeature: 'tunaPayments',
        icon: (
          <FaIcons.FaCreditCard
            style={{ fontSize: "20px" }}
          />
        ),
      },
    ],
  },
  {
    title: t('menu.administrative'),
    icon: (
      <RiAdminFill style={{ fontSize: "20px" }} />
    ),
    permission: "AdminOnly",
    rbacPermission: null, // Controlado pela permission legada "AdminOnly"
    moduleKey: null, // Admin exclusivo - controlado via permission legada
    iconClosed: (
      <RiIcons.RiArrowDownSFill
        style={{
          marginLeft: "-5px",
          fontSize: "20px",
        }}
      />
    ),
    iconOpened: (
      <RiIcons.RiArrowUpSFill
        style={{
          marginLeft: "-5px",
          fontSize: "20px",
        }}
      />
    ),

    subNav: [
      {
        title: t('menu.addPlans'),
        path: "/planos-admin",
        icon: (
          <RiFileAddFill
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.listPlans'),
        path: "/list-plans-admin",
        icon: (
          <IoIcons.IoIosPaper
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.listCompanies'),
        path: "/list-empresas",
        icon: (
          <FaIcons.FaBuilding
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.adminMenus'),
        path: "/admin-solicitacoes-cardapio",
        icon: (
          <FaIcons.FaUtensils
            style={{ fontSize: "20px" }}
          />
        ),
      },
      {
        title: t('menu.supportInbox'),
        path: "/suporte",
        icon: <FaIcons.FaComments style={{ fontSize: "20px" }} />,
      },
    ],
  }
];

/**
 * Filter sidebar items by requiredFeature.
 * Items with requiredFeature are hidden if that feature is disabled.
 * Also filters subNav items recursively.
 */
function filterByFeatures(items) {
  return items
    .filter(item => !item.requiredFeature || isFeatureEnabled(item.requiredFeature))
    .map(item => {
      if (item.subNav) {
        const filteredSubNav = item.subNav.filter(
          sub => !sub.requiredFeature || isFeatureEnabled(sub.requiredFeature)
        );
        return { ...item, subNav: filteredSubNav };
      }
      return item;
    });
}

// Public function that returns filtered sidebar data
export const getSidebarData = (t) => filterByFeatures(allSidebarData(t));

// Exportação legada para compatibilidade - usa valores padrão em português
// DEPRECADO: Preferir usar getSidebarData(t) com a função de tradução
export const SidebarData = getSidebarData((key) => {
  // Mapeamento de fallback para quando não há função de tradução
  const fallbackTranslations = {
    'menu.myOrders': 'Meus Pedidos',
    'menu.whatsapp': 'WhatsApp',
    'menu.counterOrders': 'Pedidos Balcão',
    'menu.tables': 'Salão',
    'menu.tablesManage': 'Mesas',
    'menu.waiters': 'Garçons',
    'menu.cashier': 'Caixa',
    'menu.stock': 'Estoque',
    'menu.menu': 'Cardápio',
    'menu.menuManager': 'Gestor de Cardápio',
    'menu.addons': 'Gerenciar complementos',
    'menu.reports': 'Relatórios',
    'menu.general': 'Geral',
    'menu.performance': 'Meu desempenho',
    'menu.driversFees': 'Taxas por Entregador',
    'menu.tips': 'Gorjetas',
    'menu.abandonedCarts': 'Carrinhos abandonados',
    'menu.salesByProduct': 'Vendas por Produto',
    'menu.geographicAnalysis': 'Análise Geográfica',
    'menu.customerAnalysis': 'Análise de Clientes',
    'menu.paymentMethods': 'Formas de Pagamento',
    'menu.peakHours': 'Horários de Pico',
    'menu.drivers': 'Entregadores',
    'menu.storeInfo': 'Informações da Loja',
    'menu.team': 'Equipe',
    'menu.myAccount': 'Minha Conta',
    'menu.plans': 'Planos',
    'menu.settings': 'Configurações',
    'menu.printer': 'Impressora',
    'menu.acceptedPayments': 'Formas de pagamento aceitas',
    'menu.myOrdersConfig': 'Meus pedidos',
    'menu.botConfig': 'Configurações do Bot',
    'menu.importMenu': 'Importar Cardápio',
    'menu.stockManagement': 'Gestão de Estoque',
    'menu.tunaPayments': 'Tuna Pagamentos',
    'menu.supportPrivacy': 'Privacidade do Suporte',
    'menu.administrative': 'Administrativo',
    'menu.addPlans': 'Adicionar Planos',
    'menu.listPlans': 'Listar Planos',
    'menu.listCompanies': 'Listar Empresas',
    'menu.adminMenus': 'Administrar Cardápios',
    'menu.supportInbox': 'Atendimentos',
  };
  return fallbackTranslations[key] || key;
});
